// extracted by mini-css-extract-plugin
export default {"footer-container":"footer_footer-container__vWFK5","footer-top":"footer_footer-top__YxOVu","social-icons":"footer_social-icons__pIXiZ","copy-right":"footer_copy-right__F2SD5"};